export default __webpack_public_path__ + "static/media/doc-serch.88f7b982.svg";